DatabasesListController.$inject = ['DatabaseService'];
export default function DatabasesListController(DatabaseService) {
    var ctrl = this;

    ctrl.load = load;

    ctrl.$onInit = function() {
        load();
    };

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.repository = changes.repository.currentValue;
        }
    };

    ctrl.search_test = function(database) {
        var qs = {
            command: 'search',
            id: database,
            query: '@1=_ALLRECORDS @2=103 ""',
            startRecord: 1,
            maximumRecords: 10,
            recordSchema: 'bib'
        }
        DatabaseService.get(qs).$promise.then(function(response) {
            ctrl.search_test_result = response;
        });
    }


    ////////

    function load() {
        var qs = {
        };
        if (ctrl.repository)
        {
            qs.repository = ctrl.repository;
        }
        DatabaseService.get(qs).$promise.then(function(response) {
            ctrl.content = response;
        });
    }

 
}
